import { Button, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const ReauthExplainer = ({ onContinue }: { onContinue: () => void }) => {
    return (
        <div className="space-y-l">
            <Text size="s" className="font-bold">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.reauth_heading"
                    defaultMessage="Let’s take you to your bank"
                />
            </Text>
            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.reauth_body"
                    defaultMessage="Your bank needs you to log in to confirm you’re happy to keep sharing your data. We’ll bring you straight back here afterwards."
                />
            </Text>
            <Button
                variant="primary-rounded"
                className="w-full"
                onClick={onContinue}
            >
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.reauth_continue"
                    defaultMessage="Continue to your bank"
                />
            </Button>
        </div>
    );
};
